<template>
  <section
    id="features"
    class="section"
  >
    <div class="container">
      <div class="section-title">
        <h2>AI驱动的硬件设计解决方案</h2>
        <p>
          DesignPulse整合AI技术，解决传统硬件设计中的核心痛点，提供全流程智能设计服务
        </p>
      </div>
      <div class="features-grid">
        <div class="feature-card">
          <div class="feature-icon">
            <i class="fas fa-lightbulb" />
          </div>
          <h3>需求分析</h3>
          <p>智能解析用户需求，处理非确定性描述，生成精准设计规范</p>
        </div>
        <div class="feature-card">
          <div class="feature-icon">
            <i class="fas fa-project-diagram" />
          </div>
          <h3>方案设计</h3>
          <p>AI生成多种可行方案，智能推荐最优设计路径</p>
        </div>
        <div class="feature-card">
          <div class="feature-icon">
            <i class="fas fa-microchip" />
          </div>
          <h3>器件选型</h3>
          <p>智能匹配最优元器件，大幅降低BOM成本</p>
        </div>
        <div class="feature-card">
          <div class="feature-icon">
            <i class="fas fa-drafting-compass" />
          </div>
          <h3>原理图设计</h3>
          <p>AI辅助生成精确原理图，减少人工错误</p>
        </div>
        <div class="feature-card">
          <div class="feature-icon">
            <i class="fas fa-border-all" />
          </div>
          <h3>PCB设计</h3>
          <p>自动布局布线，优化电路板设计，提升性能</p>
        </div>
        <div class="feature-card">
          <div class="feature-icon">
            <i class="fas fa-check-circle" />
          </div>
          <h3>仿真验证</h3>
          <p>实时仿真分析，确保设计符合规范要求</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup></script>

<style scoped>
.section {
  padding: 100px 0;
}

.section-title {
  text-align: center;
  margin-bottom: 60px;
}

.section-title h2 {
  font-size: 40px;
  margin-bottom: 20px;
  color: var(--secondary);
}

.section-title p {
  font-size: 18px;
  color: var(--gray);
  max-width: 700px;
  margin: 0 auto;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
}

.feature-card {
  background: var(--card-bg);
  border-radius: 16px;
  padding: 40px 30px;
  box-shadow: var(--card-shadow);
  transition: var(--transition);
  text-align: center;
  border: 1px solid var(--gray-200);
}

.feature-card:hover {
  border-color: var(--gray-400);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);
}

.feature-icon {
  width: 80px;
  height: 80px;
  background: var(--gray-100);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 25px;
  color: var(--gray-600);
  font-size: 32px;
}

.feature-card h3 {
  font-size: 22px;
  margin-bottom: 15px;
}

.feature-card p {
  color: var(--gray);
}
</style>
